import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import {
  Row,
  Col,
  Button,
  Modal, 
  ModalHeader,
  ModalBody,
  Form,
  FormGroup,
  Label,
  Input
} from "reactstrap";
import { post } from "helpers/api_helper";
import SweetAlert from "react-bootstrap-sweetalert";

//i18n
import { withTranslation } from "react-i18next";

const ModalAddCutoff = (props) => {
    const [inputCutoffTime, setInputCutoffTime] = useState('13:45:00');
    const HandlerInputCutoffTime = (e) => {
        setInputCutoffTime(e.target.value);
    };
    const [selectedValue, setSelectedValue] = useState("");
    const [options, setOptions] = useState([]);
    const [isDisabled, setIsDisabled] = useState(false);
    //alert
    const [message_alert, setmessage_alert] = useState(false)
    const [text_message_alert, settext_message_alert] = useState("")
    const [error_alert, seterror_alert] = useState(false)
    const [grade, setGrade] = useState("")
    //saving
    const [loading, setLoading] = useState(false);

    const profile = props.profile;

    useEffect(() => {
        if (!profile) return;

        const roleId = Number(profile.role_id); // paksa number
        const schoolCode = profile.school_code?.toLowerCase();

        setIsDisabled(false);
        let lCode = ''
        let sCode = ''
        if(schoolCode === "tcs") sCode = 'PIK1'
        if(schoolCode == "pik2") {
            lCode = '2'
            sCode = 'PIK2'
        }

        if (roleId === 8) {
            setOptions([
            { value: lCode + "N1-Morning", text: `N1 Morning ${sCode}`},
            { value: lCode + "N1-Afternoon", text: `N1 Afternoon ${sCode}` },
            { value: lCode + "N2", text: `N2 ${sCode}` },
            { value: lCode + "K1", text: `K1 ${sCode}` },
            { value: lCode + "K2", text: `K2 ${sCode}` },
            ]);
            setSelectedValue("");
            setGrade("ec")
        }

        else if (roleId === 8 && schoolCode === "tokyo") {
            setOptions([{ value: "To", text: "Tokyo" }]);
            setSelectedValue("");
            // setIsDisabled(true);
            setGrade("ec")
        }

        else if (roleId === 9) {
            setOptions([
                { value: lCode + "P1", text: `P1 ${sCode}` },
                { value: lCode + "P2", text: `P2 ${sCode}` },
                { value: lCode + "P3", text: `P3 ${sCode}` },
                { value: lCode + "P4", text: `P4 ${sCode}` },
                { value: lCode + "P5", text: `P5 ${sCode}` },
                { value: lCode + "P6", text: `P6 ${sCode}` },
            ]);
            setSelectedValue("");
            // setIsDisabled(true);
            setGrade("primary")
        }

        else {
            setOptions([]);
            setSelectedValue("");
        }

    }, [profile]);
    
    const saveDataCutoff = async () => {
        if (!selectedValue) {
            alert("Grade Level wajib dipilih");
            return;
        }
        let schoolId
        const gradeLevel = selectedValue.slice(0, 1)
        switch(gradeLevel){
            case "P":
                schoolId = 102;
                break;
            case "K":
                schoolId = 101
                break;
            case "N":
                schoolId = 100
                break;
            case "T":
                schoolId = 105
            case "2":
                const pik2Level = selectedValue.slice(1,2)
                if(pik2Level === "P") schoolId = 1063
                if(pik2Level === "K") schoolId = 1062
                if(pik2Level === "N") schoolId = 1061
                break;
        }
        const body = {
            grade: grade,
            cutoff_time: inputCutoffTime,
            school_id: schoolId,
            grade_level: selectedValue
        }
        try {
            setLoading(true);
            let response = await post(`/early-dismissal/cutoffs`, body)
            if (response) {
                setmessage_alert(true)
                settext_message_alert("Success Add Cutoff data")
            }
        } catch (error) {
            seterror_alert(true)
        } finally {
            setLoading(false);
        }
    }

    return(
        <>
            <Modal
                size="sm"
                centered={true}
                isOpen={props.modalShow}
                toggle={props.toggleModal}
            >
                <ModalHeader toggle={props.toggleModal}>Add Cutoff</ModalHeader>
                <ModalBody>
                    <Form>
                        <Row>
                            <Col md="12">
                                <FormGroup>
                                    <Label for="school_id">Grade Level</Label>
                                    <Input
                                        type="select"
                                        id="school_id"
                                        name="school_id"
                                        value={selectedValue}
                                        disabled={isDisabled}
                                        onChange={(e) => setSelectedValue(e.target.value)}
                                    >
                                    {!isDisabled && <option value="">Select</option>}

                                    {options.map((opt) => (
                                        <option key={opt.value} value={opt.value}>
                                        {opt.text}
                                        </option>
                                    ))}
                                    </Input>
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col md="12">
                                <FormGroup>
                                <Label for="cutoff_time">Cutoff Time</Label>
                                <input id="cutoff_time" name="cutoff_time" className="form-control" type="time"  onChange={HandlerInputCutoffTime} value={inputCutoffTime}></input>
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col md="12">
                                <div className="d-flex flex-row-reverse">
                                <Button className="btn-sm" color="danger" onClick={props.toggleModal}>
                                    Cancel
                                </Button>
                                <Button className="btn-sm mx-1" color="primary" onClick={saveDataCutoff}>
                                    {loading ? (
                                    <>
                                        <span className="spinner-border spinner-border-sm me-1" />
                                        Saving...
                                        </>
                                    ) : (
                                        "Simpan"
                                    )}
                                </Button>
                                </div>
                            </Col>
                        </Row>
                    </Form>
                </ModalBody>
            </Modal>
            {message_alert ? (
                <SweetAlert
                    title="Success!"
                    confirmBtnText="Yes"
                    success
                    confirmBtnBsStyle="primary"
                    onConfirm={() => {
                        setmessage_alert(false)
                        props.toggleModal();
                        props.onSuccess();
                    }}
                >
                    {text_message_alert}
                </SweetAlert>
                ) : null}
        
                {error_alert ? (
                <SweetAlert
                    title="Oppss!"
                    confirmBtnText="Yes"
                    error
                    confirmBtnBsStyle="primary"
                    onConfirm={() => {
                        seterror_alert(false)
                    }}
                >
                    Something wrong, please try again
                </SweetAlert>
                ) : null}
        </>
    )
}

ModalAddCutoff.propTypes = {
    toggleModal: PropTypes.any,
    modalShow: PropTypes.any,
    profile: PropTypes.object,
    onSuccess: PropTypes.any,
};

export default withTranslation()(ModalAddCutoff);